import { CommonModule } from '@angular/common';
import { Component, Input, Attribute } from '@angular/core';

export type ProgressStepperBadgeVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark';

export type ProgressStepperBadgeSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

@Component({
  selector: 'ts-progress-stepper-badge',
  templateUrl: './progress-stepper-badge.component.html',
  imports: [CommonModule]
})
export class ProgressStepperBadgeComponent {
  @Input() label: string | number | undefined = undefined;
  @Input() icon: string | undefined = undefined;
  @Input() variant: ProgressStepperBadgeVariant = 'primary';
  @Input() size: ProgressStepperBadgeSize = 'md';
  @Input() class: string | undefined = undefined;
  @Input() ngClass: string | string[] | Set<string> | { [klass: string]: any } | undefined =
    undefined;

  constructor(@Attribute('aria-label') public ariaLabel: string | undefined) {}

  classes(): string {
    return (
      `ts-progress-stepper-badge-${this.size} bg-${this.variant} text-${
        this.variant === 'light' ? 'black' : 'white'
      }` + (this.class ? ` ${this.class}` : '')
    );
  }
}
